import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../lib/api';
import { useStore } from '../lib/store';
import { LogoStacked } from '../components/Logo';

export function Verify() {
  const { token = '' } = useParams();
  const nav = useNavigate();
  const setAuth = useStore((s) => s.setAuth);
  const [err, setErr] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await api.verifySignup(token);
        if (cancelled) return;
        setAuth(r.accessToken, r.user, r.cove);
        setDone(true);
        setTimeout(() => nav('/', { replace: true }), 900);
      } catch (e: any) {
        if (cancelled) return;
        setErr(e.message || 'verification failed');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token, nav, setAuth]);

  return (
    <div className="app">
      <div className="auth-hero">
        <LogoStacked />
        {err ? (
          <>
            <h1 className="display auth-title">Link no longer works.</h1>
            <p className="muted auth-sub">{err}</p>
            <p className="auth-footnote">Try starting your signup again.</p>
          </>
        ) : done ? (
          <>
            <h1 className="display auth-title">You're in.</h1>
            <p className="muted auth-sub">Taking you to your cove…</p>
          </>
        ) : (
          <>
            <h1 className="display auth-title">Verifying…</h1>
            <p className="muted auth-sub">One moment.</p>
          </>
        )}
      </div>
    </div>
  );
}
